module.exports = __webpack_public_path__ + "media/images/icon/individual_stableford-7d6ee5386e67cbba6941d39f7e794fe5.png";